<template>
  <div class="w-full detail h-full overflow-y-auto overflow-x-hidden">
    <div class="m-10px">
      <!-- 风险区域基本信息 -->
      <div class="w-full flex text-white mb-14px text-14px">
        <span class="w-150px truncate text-right">区域名称：</span>
        <span class="truncate">{{ currentRelationData.name }}</span>
      </div>
      <div class="w-full flex text-white mb-14px text-14px">
        <span class="w-150px truncate text-right">风险等级：</span>
        <span class="truncate" :class="textColorMap(currentRelationData.riskLevelName)">{{
          currentRelationData.riskLevelName
        }}</span>
      </div>
      <div class="w-full flex text-white mb-14px text-14px">
        <span class="w-150px truncate text-right">关联报警数量：</span>
        <span class="truncate">{{ currentRelationData.alarmCount }}</span>
      </div>
      <div class="w-full flex text-white mb-14px text-14px">
        <span class="w-150px truncate text-right">设备设施风险点：</span>
        <span class="truncate">{{ currentRelationData.equipmentRiskPointCount }}</span>
      </div>
      <div class="w-full flex text-white mb-14px text-14px">
        <span class="w-150px truncate text-right">作业活动风险点：</span>
        <span class="truncate">{{ currentRelationData.jobRiskPointCount }}</span>
      </div>

      <div class="mt-15px mb-20px">
        <div class="flex justify-start item-start">
          <img src="../../../assets/images/titleIcon.png" alt="" />
          <span class="text-16px text-white ml-4px">
            风险管控“两单”“三卡”
          </span>
        </div>
        <div>
          <el-row :gutter="10" class="my-20px">
            <el-col :span="12">
              <div
                class="w-140px h-60px px-26px py-10px text-white text-14px text-center relative cursor-pointer list-bg__button flex justify-center items-center"
                @click="handleDialig('dangerIdentifyShow')"
              >
                危险有害因素辨识清单
              </div>
            </el-col>
            <el-col :span="12">
              <div
                class="w-140px h-60px px-26px py-10px text-white text-14px text-center relative cursor-pointer list-bg__button flex justify-center items-center"
                @click="handleDialig('safeControlShow')"
              >
                安全风险等级管控清单
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="my-20px">
            <el-col :span="8">
              <div class="w-90px h-120px card-bg">
                <div
                  class="w-90px h-120px text-white text-14px text-center flex justify-around items-center flex-col relative z-9999 cursor-pointer"
                  @click="handleDialig('employeeShow')"
                >
                  <img src="../../../assets/images/risk/knowIcon.png" alt="" />
                  <span class="inline-block w-70px">员工危害特性应知卡</span>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="w-90px h-120px card-bg">
                <div
                  class="w-90px h-120px text-white text-14px text-center flex justify-around items-center flex-col relative z-9999 cursor-pointer"
                  @click="handleDialig('disposeShow')"
                >
                  <img src="../../../assets/images/risk/emergencyIcon.png" alt="" />
                  <span class="inline-block w-70px">处置方法应急卡</span>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="w-90px h-120px card-bg">
                <div
                  class="w-90px h-120px text-white text-14px text-center flex justify-around items-center flex-col relative z-9999 cursor-pointer"
                  @click="handleDialig('dutyShow')"
                >
                  <img src="../../../assets/images/risk/promiseIcon.png" alt="" />
                  <span class="inline-block w-70px">安全职责承诺卡</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 隐患信息 -->
      <div>
        <div class="flex justify-between items-center">
          <div class="flex justify-start item-start">
            <img src="../../../assets/images/titleIcon.png" alt="" />
            <span class="text-16px text-white">
              区域未闭环隐患信息
            </span>
          </div>
          <span class="cursor-pointer text-yellow-300" @click="handleDialig('hiddenShow')"
            >更多》</span
          >
        </div>
        <div class="statistics_san mt-10px">
          <table
            v-loading="loading"
            border="none"
            cellpadding="0"
            cellspacing="0"
            class="table_bei"
          >
            <thead>
              <tr class="list-bg">
                <td class="w-5/12 text-left px-10px">隐患名称</td>
                <td class="w-4/12 text-left px-10px">隐患级别</td>
                <td class="w-3/12 text-right px-10px">操作</td>
              </tr>
            </thead>
            <tbody clsss="tBody" v-if="tableData && tableData.length > 0">
              <tr v-for="(item, index) in tableData" :key="index">
                <td class="w-5/12 text-left truncate px-10px" :title="item.hiddenDangerName">
                  {{ item.hiddenDangerName }}
                </td>
                <td
                  class="w-4/12 text-left truncate px-10px "
                  :title="item.hiddenDangerlevelStr"
                  :class="item.hiddenDangerlevel === 1 ? 'text-rose-500' : ''"
                >
                  {{ item.hiddenDangerlevelStr }}
                </td>
                <td
                  class="w-3/12 text-right text-[#00d1ff] px-10px cursor-pointer"
                  @click="goDetail(item)"
                >
                  详情
                </td>
              </tr>
            </tbody>
            <div v-else class="w-full h-15vh flex justify-center items-center">
              <img src="../../../assets/images/no_data@1x.png" alt="" />
            </div>
          </table>
          <div class="w-full flex justify-between items-center">
            <!-- <div class="text-12px text-white">
              共 <span class="text-14px text-[#fbaf3d]">{{ equipTotalCount }}</span> 条数据
            </div> -->
            <el-pagination
              background
              small
              :pager-count="5"
              @size-change="equipTableSizeChange"
              @current-change="equipTableCurrentChange"
              :current-page.sync="equipPageConfig.SkipCount"
              :page-size.sync="equipPageConfig.MaxResultCount"
              layout="prev, pager, next"
              :total="equipTotalCount"
              class="float-right"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- 危险有害因素辨识清单 -->
    <danger-identify-list
      v-if="dangerIdentifyShow"
      :areaId="transferProps.areaId"
      @cancel="cancel('dangerIdentifyShow')"
    ></danger-identify-list>

    <!-- 安全等级辨识清单 -->
    <safe-control-list
      v-if="safeControlShow"
      :areaId="transferProps.areaId"
      @cancel="cancel('safeControlShow')"
      :title="currentRelationData.name"
    ></safe-control-list>

    <!-- 员工危害特性应知卡列表 -->
    <EmployeeCardList
      v-if="employeeShow"
      :title="currentRelationData.name"
      :areaId="transferProps.areaId"
      @cancel="cancel('employeeShow')"
    ></EmployeeCardList>
    <!-- 处置方法应急卡列表 -->
    <DisposeCardList
      :title="currentRelationData.name"
      :areaId="transferProps.areaId"
      v-if="disposeShow"
      @cancel="cancel('disposeShow')"
    ></DisposeCardList>
    <!-- 安全职责承诺卡列表 -->
    <DutyCardList
      :title="currentRelationData.name"
      :areaId="transferProps.areaId"
      v-if="dutyShow"
      @cancel="cancel('dutyShow')"
    ></DutyCardList>
    <!-- 隐患列表 -->
    <HiddenList v-if="hiddenShow" @cancel="cancel('hiddenShow')"></HiddenList>
  </div>
</template>

<script>
import { AreaApi } from '@wiz-api/area-management'
import {
  HiddenRisksSmartScreenApi,
  HiddenDangerRectificationChecklistApi,
} from '@wiz-api/double-prevention-management'
import DangerIdentifyList from './DangerIdentifyList'
import SafeControlList from './SafeControlList'
import EmployeeCardList from './EmployeeCardList'
import DisposeCardList from './DisposeCardList'
import DutyCardList from './DutyCardList'
import HiddenList from './HiddenList'

const areaApi = new AreaApi()
const hiddenRisksSmartScreenApi = new HiddenRisksSmartScreenApi()
const hiddenDangerRectificationChecklistApi = new HiddenDangerRectificationChecklistApi()

export default {
  name: 'danger-hidden-detail',
  components: {
    DangerIdentifyList,
    SafeControlList,
    EmployeeCardList,
    DisposeCardList,
    DutyCardList,
    HiddenList,
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  computed: {
    textColorMap() {
      return (val) => {
        return (
          this.areaLevelList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.name == val
          })?.textColor || ''
        )
      }
    },
  },
  data() {
    return {
      timer: null,
      dangerIdentifyShow: false,
      safeControlShow: false,
      currentRelationData: {
        name: '',
        riskLevelName: '',
        riskLevelId: undefined,
        equipmentRiskPointCount: 0,
        jobRiskPointCount: 0,
        alarmCount: 0,
      },
      areaLevelList: [
        {
          name: '重大风险',
          textColor: 'text-[#a01c0e]',
        },
        {
          name: '较大风险',
          textColor: 'text-[#ff6c00]',
        },
        {
          name: '一般风险',
          textColor: 'text-[#fdf66d]',
        },
        {
          name: '低风险',
          textColor: 'text-[#14a3f3]',
        },
      ],
      tableData: [],
      equipPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      equipTotalCount: 0,

      employeeShow: false,
      disposeShow: false,
      dutyShow: false,
      hiddenShow: false,

      loading: false,
    }
  },
  watch: {
    'transferProps.areaId': {
      handler(newVal, oldVal) {
        this.getAreaDetail()
        this.getPointCount()
      },
      immediate: true,
    },
  },
  mounted() {
    this.getEquipList()
  },
  methods: {
    goDetail(row) {
      const routeUrl = this.$router.resolve({
        path: '/double-prevention-management/rectification/hidden-book',
        query: {
          id: row.id,
        },
      })
      window.open(routeUrl.href, '_blank')
    },
    // 事件-打开弹窗
    handleDialig(name) {
      this.initDialog()
      this.timer = setTimeout(() => {
        this[name] = true
      }, 200)
    },
    cancel(name) {
      this[name] = false
    },
    initDialog() {
      this.dangerIdentifyShow = false
      this.safeControlShow = false

      this.employeeShow = false
      this.disposeShow = false
      this.dutyShow = false
      this.hiddenShow = false
    },
    // 页码改变
    equipTableSizeChange(MaxResultCount) {
      this.equipPageConfig.MaxResultCount = MaxResultCount
      this.getEquipList()
    },
    // 页数改变
    equipTableCurrentChange(SkipCount) {
      this.equipPageConfig.SkipCount = SkipCount
      this.getEquipList()
    },
    async getEquipList() {
      this.loading = true
      const data = {
        maxResultCount: this.equipPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.equipPageConfig.SkipCount - 1) * this.equipPageConfig.MaxResultCount, // 跳过多少条
      }
      const [
        err,
        res,
      ] = await hiddenDangerRectificationChecklistApi.hiddenDangerLedgerPagedListQuery(data)
      if (!err) {
        this.tableData = res.items
        this.equipTotalCount = res.totalCount
      }
      this.loading = false
    },
    // 获取区域详情
    async getAreaDetail() {
      const [err, res] = await areaApi.get(this.transferProps.areaId)
      if (!err) {
        const { name, riskLevelName, alarmCount } = res
        this.currentRelationData.name = name || '/'
        this.currentRelationData.riskLevelName = riskLevelName || '/'
        this.currentRelationData.alarmCount = alarmCount || 0
      }
    },
    // 获取统计详情
    async getPointCount() {
      const [err, res] = await hiddenRisksSmartScreenApi.equipmentAndJobRiskPointCount({
        areaId: this.transferProps.areaId,
      })
      if (!err) {
        const { equipmentRiskPointCount, jobRiskPointCount } = res
        this.currentRelationData.equipmentRiskPointCount = equipmentRiskPointCount || 0
        this.currentRelationData.jobRiskPointCount = jobRiskPointCount || 0
      }
    },
  },

  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
    this.timer = null
  },
}
</script>

<style lang="scss" scoped>
@import '../../../assets/styles/pagination.scss';
@import '../../../assets/styles/shadow.scss';

.list-bg {
  background: var(--tableHeadBg);
  background-size: 100% 100%;
}

.list-bg__button {
  background: url('../../../assets/images/risk/btnBg.png');
  background-size: 100% 100%;
}

.card-bg {
  background: url('../../../assets/images/risk/cardBg.png');
  background-size: 100% 100%;
}

.statistics_san {
  width: 96%;

  .table_bei {
    height: 20vh;
    width: 100%;
    text-align: center;
    color: #ecedee;
    font-size: 14px;
    display: inline-block;
    .table_bei td {
      text-align: left;
    }
    thead {
      width: 100%;
      height: 36px;
      display: inline-block;
    }
    tbody {
      width: 100%;
      height: 15vh;
      overflow-y: auto;
      display: block;
    }
    thead tr {
      height: 100%;
      width: 100%;
      display: table;
      table-layout: fixed;
    }
    tbody tr {
      width: 100%;
      height: 36px; //身体部分每行的高度
      display: table;
      table-layout: fixed;
    }
  }
}

// 滚动条样式
.detail::-webkit-scrollbar {
  width: 5px !important;
  height: 2px !important;
  background: rgba(24, 41, 72, 0.4);
}

.detail::-webkit-scrollbar-thumb {
  border-radius: 10px !important;
  background: #02cfe4;
}
.detail::-webkit-scrollbar-track {
  border-radius: 10px !important;
  background: rgba(24, 41, 72, 0.4);
}
::v-deep .el-loading-mask {
  background-color: transparent !important;
  opacity: 0.5 !important;
}
</style>
